/**
 * Check — small circular check icon used in benefit / feature lists.
 */
export default function Check({ className = '' }) {
  return (
    <span
      className={
        'inline-grid place-items-center w-[22px] h-[22px] rounded-full flex-shrink-0 ' +
        'bg-brand-blue-bright/15 border border-brand-blue-bright/30 text-brand-blue-bright ' +
        className
      }
      aria-hidden="true"
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="w-3 h-3"
      >
        <polyline points="20 6 9 17 4 12" />
      </svg>
    </span>
  );
}
